export default __webpack_public_path__ + "static/media/page_not_found_background.7f57efc7.jpg";